import React, { useState, useEffect } from "react";
import Loader from "../../components/ui-components/Loader";
import { seasonsService } from "../../services/Seasons/SeasonsService";
import { appStore } from "../../stores/appStore";
import InfoMessages from "../../components/InfoMessage/InfoMessage";
import { useTranslation } from "react-i18next";
import { StyledPointsTableHead } from "./PointsTableStyle";
import { B2BResize } from "../../services/common/globalFunctions";

const PointsTable = () => {
  const { t } = useTranslation("General");
  const [pointsTable, setpointsTable] = useState([]);
  const [showLoader, setShowLoader] = useState(false);

  const { currentLeague, currentSeason, liveWeekNumber } = appStore(
    (state) => ({
      currentLeague: state.currentLeague,
      currentSeason: state.currentSeason,
      liveWeekNumber: state.liveWeekNumber,
    })
  );
  /* fetching pointstable data from seasons backend API*/
  useEffect(() => {
    getPointsTableDetails();
  }, [liveWeekNumber, currentLeague]);

  const getPointsTableDetails = async () => {
    setShowLoader(true);
    const response = await seasonsService.getPointsTable(
      +currentLeague?.leagueId || 1,
      +currentSeason || 1
    );
    let data = response.data;
    if (data.pointsTable.length > 0) {
      setpointsTable(data.pointsTable);
    } else {
      console.log("pointsTable Data not found");
    }
    setShowLoader(false);
    setTimeout(() => {
      B2BResize("Points Page");
    }, 500);
  };
  return showLoader ? (
    <div className="mb-2">
      <Loader />
    </div>
  ) : (
    <div className="px-3">
      <div className="w-100 overflow-hidden rounded-3">
        <table className="table border-light border  text-center layoutFixed text-black">
          <thead className="bg-primary text-white">
            <tr>
              <StyledPointsTableHead
                width="75%"
                className="text-start tabledata bg-primary text-white"
              >
                {t("P")}
                <span className="ms-3">{t("Team")}</span>
              </StyledPointsTableHead>
              <StyledPointsTableHead className="pe-5 bg-primary text-white">
                {t("W")}
              </StyledPointsTableHead>
              <StyledPointsTableHead className="pe-5 bg-primary text-white">
                {t("D")}
              </StyledPointsTableHead>
              <StyledPointsTableHead className="pe-5 bg-primary text-white">
                {t("L")}
              </StyledPointsTableHead>
              <StyledPointsTableHead className="pe-5 bg-primary text-white">
                {t("Pts")}
              </StyledPointsTableHead>
            </tr>
          </thead>
          <tbody>
            {pointsTable.length > 0 ? (
              pointsTable.map((team, index) => {
                return (
                  <tr key={index}>
                    <td className="bg-white text-dark">
                      <div className="d-flex align-items-center text-start position-absolute ps-0">
                        {index + 1}
                      </div>
                      <div className="d-flex align-items-center">
                        <div className="d-flex text-start ps-4">
                          <img
                            width={"24px"}
                            height={"24px"}
                            src={
                              process.env.PUBLIC_URL +
                              "/assets/images/teams/" +
                              team?.leagueRef +
                              "/" +
                              team.teamImageURL
                            }
                            alt=""
                          />
                        </div>
                        <div className="ps-2 d-flex text-start text-truncate">
                          <div className=" text-truncate">
                            {t(`${team.teamName}`)}
                          </div>
                        </div>
                      </div>
                    </td>
                    <td className="flex-column bg-white text-dark">
                      <div className="d-flex align-items-center">
                        <div className="text-center">{team.won}</div>
                      </div>
                    </td>
                    <td className="flex-column bg-white text-dark">
                      <div className="d-flex align-items-center">
                        <div className="text-center">{team.draw}</div>
                      </div>
                    </td>
                    <td className="flex-column bg-white text-dark">
                      <div className="d-flex align-items-center">
                        <div className="text-center">{team.lost}</div>
                      </div>
                    </td>
                    <td className="flex-column bg-white text-dark">
                      <div className="d-flex align-items-center">
                        <div className="text-center">{team.points}</div>
                      </div>
                    </td>
                  </tr>
                );
              })
            ) : (
              <tr>
                <td colSpan={5} className="flex-column">
                  <InfoMessages messages={<div>{t("No Data found")}</div>} />
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};
export default PointsTable;
